import zh from './zh'
import zhTw from './zhTw'
import en from './en'
import ko from './ko'
import ja from './ja'
import hi from './hi'
import vi from './vi'
import th from './th'
import tr from './tr'
import bn from './bn'
import es from './es'
import pt from './pt'

const packs = { zh, zhTw, en, ko, ja, hi, vi, th, tr, bn, es, pt }

export const LOCALE_IDS = Object.keys(packs)

const ALIASES = {
  'zh-cn': 'zh',
  'zh-hans': 'zh',
  'zh-tw': 'zhTw',
  'zh-hant': 'zhTw',
  zh_hant: 'zhTw'
}

export function normalizeLocale(lang) {
  const raw = (lang || '').trim()
  if (!raw) return null
  const lower = raw.toLowerCase()
  if (ALIASES[lower]) return ALIASES[lower]
  if (packs[raw]) return raw
  const primary = lower.split('-')[0].split('_')[0]
  if (ALIASES[primary]) return ALIASES[primary]
  if (packs[primary]) return primary
  return null
}

export function isValidLocale(lang) {
  return normalizeLocale(lang) != null
}

const STORAGE_KEY = 'cashier_locale'
const DEFAULT_LOCALE = 'en'

function getLangFromUrl() {
  if (typeof window === 'undefined') return null
  const hash = window.location.hash || ''
  const qIdx = hash.indexOf('?')
  if (qIdx >= 0) {
    const fromHash = new URLSearchParams(hash.slice(qIdx + 1)).get('lang')
    if (fromHash) return fromHash
  }
  const fromSearch = new URLSearchParams(window.location.search).get('lang')
  return fromSearch || null
}

function detectNavigatorLocale() {
  if (typeof navigator === 'undefined') return null
  const langs =
    navigator.languages && navigator.languages.length
      ? navigator.languages
      : [navigator.language || '']
  for (const raw of langs) {
    const id = normalizeLocale(raw)
    if (id) return id
  }
  return null
}

/** 1. URL ?lang=  2. localStorage  3. 浏览器语言  4. en */
function resolveInitialLocale() {
  const urlId = normalizeLocale(getLangFromUrl())
  if (urlId) return urlId
  const storedId = normalizeLocale(localStorage.getItem(STORAGE_KEY))
  if (storedId) return storedId
  const navId = detectNavigatorLocale()
  if (navId) return navId
  return DEFAULT_LOCALE
}

let locale = typeof window !== 'undefined' ? resolveInitialLocale() : DEFAULT_LOCALE

export function setLocale(lang) {
  const id = normalizeLocale(lang)
  if (!id) return
  locale = id
  localStorage.setItem(STORAGE_KEY, id)
}

export function getLocale() {
  return locale
}

/** 商户链接 ?lang= 为最高优先级 */
export function applyLocaleFromUrl(lang) {
  const id = normalizeLocale(lang)
  if (!id) return null
  setLocale(id)
  return id
}

const fallback = () => packs.en || packs.zh

export const i18n = {
  t(key) {
    const p = packs[locale] || fallback()
    if (p[key] != null) return p[key]
    const fb = fallback()
    return fb[key] != null ? fb[key] : key
  },
  locales: [
    { id: 'zh', label: '简体中文' },
    { id: 'zhTw', label: '繁體中文' },
    { id: 'en', label: 'English' },
    { id: 'ko', label: '한국어' },
    { id: 'ja', label: '日本語' },
    { id: 'hi', label: 'हिन्दी' },
    { id: 'vi', label: 'Tiếng Việt' },
    { id: 'th', label: 'ไทย' },
    { id: 'tr', label: 'Türkçe' },
    { id: 'bn', label: 'বাংলা' },
    { id: 'es', label: 'Español' },
    { id: 'pt', label: 'Português' }
  ]
}
